import { useNavigate } from 'react-router';
import type { NavigationItem } from '@/types/layout.types';
import { usePointerActivation } from '@/hooks';
import { cn } from '@/utils';

export function SidebarNavItem({
	item,
	isActive,
	onClose,
}: {
	item: NavigationItem;
	isActive: boolean;
	onClose: () => void;
}) {
	const navigate = useNavigate();
	const action = () => {
		navigate(item.href!);
		onClose();
	};
	const pointerProps = usePointerActivation(action);

	return (
		<li>
			<button
				type="button"
				{...pointerProps}
				className={cn(
					'w-full flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors',
					isActive ? 'bg-blue-500/20 text-blue-400' : 'text-gray-300 hover:bg-white/10'
				)}
			>
				<item.icon className="w-5 h-5 text-[#F7F7F8]" />
				{item.tabName}
			</button>
		</li>
	);
}
